var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StarRating',_vm._b({ref:"starRating",class:{ disabled: _vm.disabled },model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'StarRating',{
    maxRating: _vm.maxRating,
    readOnly: _vm.readOnly,
    fixedPoints: _vm.digits,
    starSize: _vm.size,
    increment: _vm.step,
  },false))
}
var staticRenderFns = []

export { render, staticRenderFns }